import { TariffModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/tariff/tariff.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface TariffListOcpiTariffIdHeaderProps
  extends HeaderContext<TariffModel, TariffModel['ocpiTariffId']> {}

export const TariffListOcpiTariffIdHeader =
  (): // props: TariffListOcpiTariffIdHeaderProps,
  ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return t('delmonicos-shared-sdk.outputs-tariff.ocpi-tariff-id');
  };
